export const STEP = {
  INTRO: 'INTRO',
  BRAND: 'BRAND',
  COMPETITORS: 'COMPETITORS',
  COMPLETE: 'COMPLETE',
} as const;

export type StepIntroMap = {
  [key in Extract<Steps, 'INTRO'>]: {
    subTitle: string;
  };
};

export type StepCompleteMap = {
  [key in Extract<Steps, 'COMPLETE'>]: {
    loader: {
      headline: string;
      note1: string;
      note2: string;
    };
  };
};

export type StepRestMap = {
  [key in Exclude<Steps, 'INTRO' | 'COMPLETE'>]: {
    subTitle: string;
    loader?: {
      headline: string;
      note1: string;
      note2: string;
    };
    disclaimer: string;
    dialog: {
      headline: string;
      description: string;
      actionConfirm: string;
      actionCancel: string;
      fieldName: string;
      fieldUrl: string;
    };
  };
};

export type Steps = keyof typeof STEP;
